import { createFileRoute } from '@tanstack/react-router';
import { LedgerTransfersPage } from './LedgerTransfersPage';
import { z } from 'zod';

const searchSchema = z.object({
  fromAccountId: z.string().optional(),
  toAccountId: z.string().optional(),
  eitherAccountId: z.string().optional(),
  accountName: z.string().optional(),
  user: z.string().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().positive().int().optional().default(25),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/ledger/transfers/')({
  component: LedgerTransfersPage,
  validateSearch: searchSchema,
});
